import dayjs from 'dayjs';

export const formatUploadDateTime = (
  date: dayjs.Dayjs,
  time: dayjs.Dayjs | null,
): string => {
  const timePart = time?.format('HH:mm') ?? '00:00';
  return `${date.format('YYYY-MM-DD')}T${timePart}:00`;
};
